import { getThemedData } from '$app/utilities'

import carro from './carro'
import motto from './motto'
import partner from './partner'

export const Logo = getThemedData({
  motto,
  carro,
  partner
})

export default Logo
